import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for my designs
const myDesignsData = [{
  id: 'MD001',
  name: 'Western Field Pivot System',
  description: 'Main field irrigation system',
  date: 'Aug 05, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  lastModified: '2025-08-05',
  tags: ['Standard', 'Full-Circle']
}, {
  id: 'MD002',
  name: 'Eastern Linear System',
  description: 'Linear system for rectangular field',
  date: 'Jul 28, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  lastModified: '2025-07-28',
  tags: ['Linear', 'High-Flow']
}, {
  id: 'MD003',
  name: 'South Field Corner System',
  description: 'Corner arm addition to existing pivot',
  date: 'Jul 15, 2025',
  status: 'pending',
  model: 'Corner Arm',
  pivotCount: 1,
  specs: {
    length: '70.00 m',
    angle: 'N/A',
    area: '+8.00 ha',
    flow: '+18.00 l/s',
    pressure: '2.30 bar'
  },
  lastModified: '2025-07-15',
  tags: ['Corner', 'Upgrade']
}];
export function MyDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = myDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2652">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2653">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2654">
          <div className="flex justify-between items-start" data-id="element-2655">
            <div data-id="element-2656">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2657">
                My Designs
              </h3>
              <p className="text-4xl font-bold text-blue-600" data-id="element-2658">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2659">
              <PencilRulerIcon size={24} className="text-blue-600" data-id="element-2660" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-2661">
            Last updated: {new Date().toLocaleDateString()}
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2662">
          <div className="flex justify-between items-start" data-id="element-2663">
            <div data-id="element-2664">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2665">Status</h3>
              <div className="mt-2" data-id="element-2666">
                <div className="flex justify-between text-sm mb-1" data-id="element-2667">
                  <span data-id="element-2668">Active</span>
                  <span className="font-medium" data-id="element-2669">
                    {filteredDesigns.filter(d => d.status === 'active').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2670">
                  <span data-id="element-2671">Completed</span>
                  <span className="font-medium" data-id="element-2672">
                    {filteredDesigns.filter(d => d.status === 'completed').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2673">
                  <span data-id="element-2674">Pending</span>
                  <span className="font-medium" data-id="element-2675">
                    {filteredDesigns.filter(d => d.status === 'pending').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-green-100 p-2 rounded-lg" data-id="element-2676">
              <UserIcon size={24} className="text-green-600" data-id="element-2677" />
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2678">
          <div className="flex justify-between items-start" data-id="element-2679">
            <div data-id="element-2680">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2681">Models</h3>
              <div className="mt-2" data-id="element-2682">
                <div className="flex justify-between text-sm mb-1" data-id="element-2683">
                  <span data-id="element-2684">Pivot CP600</span>
                  <span className="font-medium" data-id="element-2685">
                    {filteredDesigns.filter(d => d.model === 'Pivot CP600').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2686">
                  <span data-id="element-2687">Linear</span>
                  <span className="font-medium" data-id="element-2688">
                    {filteredDesigns.filter(d => d.model === 'Linear').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2689">
                  <span data-id="element-2690">Corner Arm</span>
                  <span className="font-medium" data-id="element-2691">
                    {filteredDesigns.filter(d => d.model === 'Corner Arm').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2692">
              <RulerIcon size={24} className="text-indigo-600" data-id="element-2693" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2694">
        <div className="text-gray-700 font-medium" data-id="element-2695">
          {filteredDesigns.length} designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2696">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2697">
            <ListIcon size={16} className="mr-1" data-id="element-2698" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2699">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2700" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2701">
            <FoldersIcon size={16} className="mr-1" data-id="element-2702" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2703">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2704" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2705">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2706" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2707">
              No designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2708">
          <table className="w-full" data-id="element-2709">
            <thead className="bg-gray-50" data-id="element-2710">
              <tr data-id="element-2711">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2712">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2713">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2714">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2715">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2716">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2717">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2718">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2719">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2720">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2721">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2722">
                    <div className="font-medium" data-id="element-2723">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2724">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2725">
                    <div className="flex items-center" data-id="element-2726">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-2727" />
                      <div data-id="element-2728">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-2729">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2730">
                    <div className="flex gap-2 text-xs" data-id="element-2731">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2732">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2733">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-2734">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2735">
                    {design.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2736">
                    <StatusBadge status={design.status} data-id="element-2737" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2738">
                    <div className="flex space-x-2" data-id="element-2739">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2740">
                        <EyeIcon size={16} data-id="element-2741" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2742">
                        <EditIcon size={16} data-id="element-2743" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2744">
                        <ShareIcon size={16} data-id="element-2745" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2746">
              No designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2747">
      <div className="p-5 border-b border-gray-100" data-id="element-2748">
        <div className="flex justify-between items-start" data-id="element-2749">
          <div data-id="element-2750">
            <div className="flex items-center" data-id="element-2751">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2752">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2753">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2754">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2755">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2756">
        <div className="flex items-center" data-id="element-2757">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2758" />
          <div data-id="element-2759">
            <div className="text-sm font-medium text-gray-900" data-id="element-2760">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2761">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-2762">
          <div className="text-xs text-gray-500 flex items-center justify-end" data-id="element-2763">
            <CalendarIcon size={12} className="mr-1" data-id="element-2764" />
            {design.date}
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-2765">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-2766">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-2767">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-2768">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-2769">
              <RulerIcon size={12} className="mr-1" data-id="element-2770" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2771">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-2772">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-2773">
              <PieChartIcon size={12} className="mr-1" data-id="element-2774" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2775">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-2776">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-2777">
              <DropletIcon size={12} className="mr-1" data-id="element-2778" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2779">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-2780">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-2781">
              <TagIcon size={10} className="mr-1" data-id="element-2782" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-2783">
        <div className="flex space-x-2" data-id="element-2784">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-2785">
            <EyeIcon size={14} className="mr-1" data-id="element-2786" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-2787">
            <EditIcon size={14} className="mr-1" data-id="element-2788" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-2789">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2790">
            <ShareIcon size={16} data-id="element-2791" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2792">
            <DownloadIcon size={16} data-id="element-2793" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-2794">
      {config.text}
    </span>;
}